export default __webpack_public_path__ + "static/media/link-new-tab.67381aaa.svg";